import dayJs from "dayjs";
import { qiniuImageURLPrefix } from '@/config/qiniu'

// 定义过滤器函数

/**
 * 绑定数据，若值为''等情况，渲染成‘-’
 * @param {*} value
 */
export const getNullVal = (value) => {
  if (value == "" || value == undefined) return "-";
  return value;
};

// 自定义打印合计列精度处理
export const getSumNullVal = (value) => {
  if (value == "" || value == undefined) return "-";
  value = Number(parseFloat(value).toFixed(2));
  return value;
};

/**
 * 绑定数据，将数字金额转为大写
 * @param {*} value
 */
export const upMoney = (n) => {
  if (n == "") return "";
  if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) return "数据非法";
  let unit = "京亿万仟佰拾兆万仟佰拾亿仟佰拾万仟佰拾元角分",
    str = "";
  n += "00";
  let p = n.indexOf(".");
  if (p >= 0) n = n.substring(0, p) + n.substr(p + 1, 2);
  unit = unit.substr(unit.length - n.length);
  for (let i = 0; i < n.length; i++)
    str += "零壹贰叁肆伍陆柒捌玖".charAt(n.charAt(i)) + unit.charAt(i);
  return str
    .replace(/零(仟|佰|拾|角)/g, "零")
    .replace(/(零)+/g, "零")
    .replace(/零(兆|万|亿|元)/g, "$1")
    .replace(/(兆|亿)万/g, "$1")
    .replace(/(京|兆)亿/g, "$1")
    .replace(/(京)兆/g, "$1")
    .replace(/(京|兆|亿|仟|佰|拾)(万?)(.)仟/g, "$1$2零$3仟")
    .replace(/^元零?|零分/g, "")
    .replace(/(元|角)$/g, "$1整");
};

/**
 * 员工列表，接口是旧版的，部分图片地址还是旧项目结构下的静态资源地址，需要转换成vue项目下的地址。使用type来扩展
 * @param {*} value 本身值
 * @param {*} type  类型： 1：图像默认图；2：商品默认图；3：门头照片默认图，4：默认企业客户头像，5：货品类目
 * 备注：图像的处理统一使用changeImgUrl或者qiniuImage，请不要新增其它方法
 */
export const changeImgUrl = (value, type) => {
  if (!value || value.indexOf("static") > -1) {
    // 如果图片为空或者后端返回的是static开头的图片地址
    if (type === 1) {
      return defaultSatffImgUrl;
    } else if (type === 2) {
      return defaultGoodsImgUrl;
    } else if (type === 3) {
      return defaultShopImgUrl;
    } else if (type === 4) {
      return defaultCompanyImgUrl;
    } else if (type == 5) {
      return defaultGoodsImgUrl;
    }
  } else {
    if (!value.startsWith("http")) {
      // 七牛云的图片加上域名前缀
      value = qiniuImageURLPrefix + value;
      if (type === 3) {
        value += "?imageView2/1/w/100/h/100";
      } else if (type === 5) {
        value += "?imageView2/1/w/100/h/100";
      }
    }
    return value;
  }
};

// 处理系统头像（备注：图像的处理统一使用changeImgUrl或者qiniuImage，请不要新增其它方法）
export function qiniuImage(value, devImg) {
  if (!value) return devImg || defaultSatffImgUrl;
  value = value + "";
  if (value.indexOf("static") > -1) {
    // 本地默认图片
    return devImg || defaultSatffImgUrl;
  } else {
    if (value.startsWith("http")) {
      // 正常图片
      return value;
    } else if (value.indexOf(qiniuImageURLPrefix) == -1) {
      // 七牛云拼接图片地址
      value = qiniuImageURLPrefix + value;
    }
    return value;
  }
}

/**
 * 日期是否是今天或者明天，返回出中文“今天”、“明天”
 * @param {*} value 日期值
 */
export const isToday = (value) => {
  let day1 = new Date();
  day1.setTime(day1.getTime());
  let s1_m = day1.getMonth() + 1;
  let s1_d = day1.getDate();
  s1_m = s1_m > 9 ? s1_m : "0" + s1_m;
  s1_d = s1_d > 9 ? s1_d : "0" + s1_d;
  let s1 = day1.getFullYear() + "-" + s1_m + "-" + s1_d;

  let day2 = new Date();
  let s2_d = parseInt(day2.getDate());
  day2.setDate(s2_d + 1);
  let s2_m = day2.getMonth() + 1;
  s2_d = day2.getDate();
  s2_m = s2_m > 9 ? s2_m : "0" + s2_m;
  s2_d = s2_d > 9 ? s2_d : "0" + s2_d;
  let s2 = day2.getFullYear() + "-" + s2_m + "-" + s2_d;

  if (value == s1) {
    return "今天";
  } else if (value == s2) {
    return "明天";
  } else {
    return value;
  }
};

/**
 * 保留两位小数
 * @param {*} value
 */
export const toFix2 = (value) => {
  if (Number.isInteger(value) || isNaN(value)) {
    return value;
  } else {
    return Number(value.toFixed(2));
  }
};

/**
 * 格式化金额，金额小数最长取2位
 * @param {Number, String} val
 * @param {Number} len
 */
// todo: 参数过多，需要了考虑对象，或者调整参数的位置。
let moneyFormat = null;
export const formatMoney = (
  val,
  len = 2,
  defaultStr = 0,
  isCurrency = false
) => {
  if (!moneyFormat) {
    moneyFormat = new Intl.NumberFormat("zh-Hans-CN");
  }
  let tmp = Number(val);
  if (Number.isNaN(tmp)) return defaultStr;

  const base = Math.pow(10, len);
  tmp = Math.round(tmp * base) / base;
  return isCurrency && moneyFormat ? moneyFormat.format(tmp) : tmp;
};

/**
 * 处理多选框fliterData, 将对象转换为数组
 * @param {*} data
 */
export const dealFilterData = (data) => {
  if (Object.prototype.toString.call(data) == "[object Array]") {
    return data;
  }
  let filterData = [];
  for (const i in data) {
    let arr = {};
    arr.id = i;
    arr.name = data[i];
    filterData.push(arr);
  }
  return filterData;
};

/**
 * 处理多选框fliterData, 将对象转换为数组
 * @param {*} data
 */
export const dealFilterDataForArray = (data) => {
  let filterData = [];
  if (Object.prototype.toString.call(data) == "[object Array]") {
    filterData = data.map((key) => {
      let arr = {};
      arr.id = key;
      arr.name = key || "无批次号";
      return arr;
    });
  }
  return filterData;
};

// 处理批次号数据
export const dealBatchNumForArray = (data) => {
  let filterData = [];
  if (Object.prototype.toString.call(data) == "[object Array]") {
    filterData = data.map((key) => {
      let arr = {};
      arr.id = key || ",";
      arr.name = key || "无批次号";
      return arr;
    });
  }
  return filterData;
};

//处理时间格式
export const dealWithTime = (value, column) => {
  const realWidth = column.realWidth;
  if (value == "-") {
    return value;
  }
  if (value && realWidth < 170) {
    value = value.split(" ");
    value = value[0] + "\n" + value[1];
  }
  return value;
};

function getLabelDataByCode(code, dataArray) {
  let mapData = {
    label: "",
    children: [],
  };
  if (!dataArray) return mapData;
  for (let i = 0; i < dataArray.length; i++) {
    let data = dataArray[i];
    if (data.value != code) continue;
    mapData.label = data.label;
    mapData.children = data.children;
  }
  return mapData;
}
//通过code获取地区名称
export const getMapDataByCode = (provinceCode, cityCode, districtCode) => {
  const provinceData = getLabelDataByCode(provinceCode, SG_AREA);
  const provinceChildren = provinceData.children;
  const cityData = getLabelDataByCode(cityCode, provinceChildren);
  const cityChildren = cityData.children;
  const districtData = getLabelDataByCode(districtCode, cityChildren);
  let provinceLabel = provinceData.label;
  let cityLabel = cityData.label;
  let districtLabel = districtData.label;
  cityLabel = cityLabel ? " " + cityLabel : " ";
  districtLabel = districtLabel ? " " + districtLabel : " ";
  return provinceLabel + cityLabel + districtLabel;
};

// 计算某一时间距离今天的天数
export const computedDays = (value) => {
  value += "";
  const nowDate = new Date().getTime();
  const startDate = new Date(value).getTime();
  let days = Math.ceil((nowDate - startDate) / (24 * 60 * 60 * 1000));
  return days;
};

// 获取收支类型
export const getInexpendType = (value) => {
  let name;
  for (let i in InAndExpendType) {
    let item = InAndExpendType[i];
    if (item.id == value) {
      name = item.name;
      break;
    }
  }
  return name;
};

// 获取收支类型class
export const getInexpendClass = (value) => {
  let className = "";
  if (value == 1) {
    className = "inColor";
  } else if (value == 2) {
    className = "outColor";
  } else if (value == 3) {
    className = "c333";
  }
  return className;
};

// 获取关联角色
export const getLinkRole = (value) => {
  return LinkRole[value];
};

// 获取货品类型
export const getGoodsSupplyType = (value) => {
  let text = "";
  for (let i in allGoodsType) {
    const item = allGoodsType[i];
    if (item.id == value) {
      text = item.text;
      break;
    }
  }
  return text;
};

/**
 * 时间格式化
 * @param {string} type 需要输出的类型,请确保是受支持的类型，不传不应用
 */
export const formatTimeShow = (time, type) => {
  if (!time) return time;
  const target = dayJs(time);
  const now = dayJs();
  const diffValue = now.diff(target);
  if (type) {
    return dayJs(target).format(type);
  }
  if (diffValue < 1000 * 60) {
    // 小于一分钟
    return "刚刚";
  } else if (diffValue >= 1000 * 60 && diffValue < 1000 * 60 * 60) {
    // 大于一分钟小于一小时
    return parseInt(diffValue / (1000 * 60)) + "分钟前";
  } else if (target.isBefore(now, "year")) {
    // 今年以前
    return dayJs(target).format("YYYY年MM月DD日 HH:mm:ss");
  } else if (target.isBefore(now.subtract(1, "day"), "day")) {
    // 昨天以前 今年以内
    return dayJs(target).format("MM月DD日 HH:mm:ss");
  } else if (target.isBefore(now, "day")) {
    // 昨天
    return dayJs(target).format("昨天 HH:mm:ss");
  } else if (diffValue >= 1000 * 60 * 60) {
    // 大于60分钟
    return dayJs(target).format("HH:mm:ss");
  }
};

/**
 * 格式化显示货品单位
 * @param {*} row 行数据对象
 * @param {*} type 展示的货品信息
 * @param {*} format 替换字段
 */
const defaultVerb = {
  // 销售数量
  commission_mul: "commission_mul",
  quantity_unit_text: "quantity_unit_text",
  // 销售重量
  sales_num: "sales_num",
  weight_unit_text: "weight_unit_text",
  // 行费价格
  commission: "commission",
  commission_unit_text: "commission_unit_text",
  // 押金价格
  deposit: "deposit",
  deposit_unit_text: "deposit_unit_text",
  // 货品销售单价
  unit_price: "unit_price",
  sale_unit_text: "sale_unit_text",
};
export function formatGoodsUnit(row, type, obj = {}) {
  const verb = Object.assign({}, defaultVerb, obj);
  let retStr = "";
  switch (type) {
    // 销售数量
    case "commission_mul":
      retStr = row[verb.commission_mul]
        ? row[verb.commission_mul] + (row[verb.quantity_unit_text] || "")
        : "-";
      break;
    // 销售重量
    case "sales_num":
      retStr = row[verb.sales_num]
        ? `${row[verb.sales_num]}${row[verb.weight_unit_text] || ""}`
        : "-";
      break;
    // 单价
    case "unit_price":
      retStr = row[verb.unit_price]
        ? `${row[verb.unit_price]}元/${row[verb.sale_unit_text]}`
        : "-";
      break;
    // 行费单价
    case "commission":
      retStr = row[verb.commission]
        ? `${row[verb.commission]}元/${row[verb.commission_unit_text]}`
        : "-";
      break;
    // 押金单价
    case "deposit":
      retStr = row[verb.deposit]
        ? `${row[verb.deposit]}元/${row[verb.deposit_unit_text]}`
        : "-";
      break;
    default:
      break;
  }

  return retStr;
}

/**
 * 新版表头展示单位
 * @param {*} val 字符串或数值类型
 * @param {*} item 含有 unit_name 和 show_unit 的对象
 */
export function showUnitInTableColumns(val, item, customUnitName = "") {
  val = getNullVal(val);
  if (val === "-") return val;
  if (item.show_unit === 1) {
    return `${val}${
      item.unit_name === "-" || customUnitName ? customUnitName : item.unit_name
    }`;
  }
  return val;
}

export const getNullValNew = (value) => {
  if (value == "" || value == undefined || value == "-") return "/";
  return value;
};
